import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NavigationState {
  // Mobile nav collapse state
  isNavCollapsed: boolean;
  toggleNavCollapsed: () => void;
  setNavCollapsed: (collapsed: boolean) => void;

  // UX hint: hide Top-3 red dot immediately after generation
  top3JustGenerated: boolean;
  setTop3JustGenerated: (value: boolean) => void;
}

export const useNavigationStore = create<NavigationState>()(
  persist(
    (set) => ({
      isNavCollapsed: true, // Start collapsed on mobile
      toggleNavCollapsed: () => 
        set((state) => ({ isNavCollapsed: !state.isNavCollapsed })),
      setNavCollapsed: (collapsed) => 
        set({ isNavCollapsed: collapsed }),

      top3JustGenerated: false,
      setTop3JustGenerated: (value) => set({ top3JustGenerated: value }),
    }),
    {
      name: 'navigation-store',
      partialize: (state) => ({
        isNavCollapsed: state.isNavCollapsed,
        top3JustGenerated: state.top3JustGenerated,
      }),
    }
  )
);